import { revenueSeries } from "@/mocks/admin";

export default function RevenueChart() {
  const max = Math.max(...revenueSeries.map((p) => p.revenue));
  const min = Math.min(...revenueSeries.map((p) => p.revenue));
  const width = 600;
  const height = 220;
  const padX = 32;
  const padY = 24;
  const innerW = width - padX * 2;
  const innerH = height - padY * 2;

  const points = revenueSeries.map((p, i) => {
    const x = padX + (i / (revenueSeries.length - 1)) * innerW;
    const y =
      padY + innerH - ((p.revenue - min) / Math.max(1, max - min)) * innerH;
    return { x, y, ...p };
  });

  const linePath = points
    .map((p, i) => `${i === 0 ? "M" : "L"}${p.x.toFixed(1)},${p.y.toFixed(1)}`)
    .join(" ");

  const areaPath = `${linePath} L${points[points.length - 1].x.toFixed(
    1,
  )},${(padY + innerH).toFixed(1)} L${points[0].x.toFixed(1)},${(padY + innerH).toFixed(
    1,
  )} Z`;

  return (
    <div className="w-full">
      <div className="relative w-full">
        <svg
          viewBox={`0 0 ${width} ${height}`}
          className="w-full h-auto"
          preserveAspectRatio="none"
        >
          <defs>
            <linearGradient id="revFill" x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor="oklch(var(--primary-500))" stopOpacity="0.28" />
              <stop offset="100%" stopColor="oklch(var(--primary-500))" stopOpacity="0" />
            </linearGradient>
          </defs>

          {/* gridlines */}
          {[0, 1, 2, 3].map((i) => {
            const y = padY + (innerH / 3) * i;
            return (
              <line
                key={i}
                x1={padX}
                x2={width - padX}
                y1={y}
                y2={y}
                stroke="oklch(var(--background-300))"
                strokeOpacity="0.5"
                strokeDasharray="3 4"
              />
            );
          })}

          <path d={areaPath} fill="url(#revFill)" />
          <path
            d={linePath}
            fill="none"
            stroke="oklch(var(--primary-500))"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

          {points.map((p) => (
            <g key={p.label}>
              <circle
                cx={p.x}
                cy={p.y}
                r={4}
                fill="oklch(var(--background-50))"
                stroke="oklch(var(--primary-500))"
                strokeWidth="2"
              />
            </g>
          ))}
        </svg>
      </div>
      <div className="grid grid-cols-6 mt-2 px-2">
        {revenueSeries.map((p) => (
          <div key={p.label} className="text-center">
            <p className="text-[11px] text-foreground-600">{p.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}